<template>
  <div>
    <header-applis titre="Personnaliser l'offre à votre profil" sous-titre="Adapter son action face à des aléas" index-progression-courante="3" index-progression-secondaire="12"/>
    <choix-competence-repeater :competences="competences" :callback="sauvegarder"/>
    <skip-competences ecrant-suivant="questionsprofils"/>
    <footer-applis ecran-precedent="realiseractivite" ecran-suivant="questionsprofils" label-suivant="Je ne souhaite pas répondre aux questions"/>
  </div>
</template>

<script>
import HeaderApplis from '../../components/HeaderApplis';
import FooterApplis from '../../components/FooterApplis';
import ChoixCompetenceRepeater from '../../components/ChoixCompetenceRepeater';
import SkipCompetences from '../../components/SkipCompetences';

export default {
  name: 'adapteraction',
  components: {
    SkipCompetences,
    ChoixCompetenceRepeater,
    HeaderApplis,
    FooterApplis
  },
  data() {
    return {
      competences: [{
        niveau: 1,
        valeur: 'J\'identifie et signale la nature d’un problème'
      }, {
        niveau: 2,
        valeur: 'Je propose une solution à un/des problèmes, fais vérifier sa pertinence'
      }, {
        niveau: 3,
        valeur: 'Je résous des problèmes variés, et explicite les modalités les plus adaptées à chaque situation'
      }, {
        niveau: 4,
        valeur: 'J\'anticipe sur des problèmes pouvant survenir dans mon activité, modifie certaines façons de faire'
      }]
    }
  },
  methods: {
    competencesTransversales() {
      return this.$store.getters.getCompetencesTansversales;
    },
    sauvegarder(competence) {
      let informations = {};
      Object.assign(informations, this.competencesTransversales());
      informations.adapteraction = competence;
      this.$store.commit('setCompetencesTransversales', informations);
      this.$router.push('questionsprofils');
    }
  }
}
</script>
